import { render, staticRenderFns } from "./PromoView.vue?vue&type=template&id=3d2925c3&scoped=true&"
import script from "./PromoView.vue?vue&type=script&lang=js&"
export * from "./PromoView.vue?vue&type=script&lang=js&"
import style0 from "./PromoView.vue?vue&type=style&index=0&id=3d2925c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2925c3",
  null
  
)

export default component.exports